import { defineStore } from 'pinia';



export const useLinkStore = defineStore("main", {
    state: () => ({
        wuerfe: [
            {
                id: "wurfA",
                title: "A-Wurf",
                link: "/wuerfe/A",
                data: {
                    sire: {
                        name: "Nova Scotia's Big Boss (Bibo)",
                        link: "http://www.novascotias-mainecoons.de/crew/kater/bibo/",
                    },
                    dam: {
                        name: "Nova Scotia's Sirona",
                        link: "http://www.novascotias-mainecoons.de/crew/kater/bibo/",
                    }
                }
            },
            {
                id: "wurfB",
                title: "B-Wurf",
                link: "/wuerfe/B",
            },
        ],
        footerLinks: [
            {
                id: "freundeBtn",
                title: 'Zuchtfreunde',
                link: '/zuchtfreunde',
            },
            {
                id: "wissenswertesBtn",
                title: 'Wissenswertes',
                link: '/wissenswertes',
            },
            {
                id: "dokumenteBtn",
                title: 'Dokumente',
                link: '/dokumente',
            },
            {
                id: "impressumBtn",
                title: 'Impressum',
                link: '/impressum',
            },
            {
                id: "datenschutzBtn",
                title: 'Datenschutz',
                link: '/datenschutz',
            },
        ],
        navLinks: [
            {
                id: "catteryBtn",
                title: 'Unsere Cattery',
                link: '/cattery',
            },
            {
                id: "wurfBtn",
                title: 'Würfe',
                link: '/wuerfe',
            },
            {
                id: "aktuellesBtn",
                title: 'Aktuelles',
                link: '/aktuelles',
            },
            {
                id: "crewBtn",
                title: 'Crew',
                link: '/crew',
            },
        ],
    }),
    getters: {
    },
    actions: {
    }
});
